import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ReactDOM from 'react-dom';

class ConfirmDelete extends PureComponent {
  div = document.createElement('div');
  divRef = React.createRef();
  deleteRef = React.createRef();
  state = {
    isShowConfirm: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowConfirm } = this.state;
    if (isShowConfirm === prevState.isShowConfirm) {
      return;
    }
    if (isShowConfirm) {
      document.body.appendChild(this.div);
      window.addEventListener('mousedown', this.onMouseDown);
      return;
    }
    document.body.removeChild(this.div);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.onMouseDown);
    const { isShowConfirm } = this.state;
    if (isShowConfirm) {
      document.body.removeChild(this.div);
    }
  }

  onMouseDown = e => {
    const { isShowConfirm } = this.state;
    const isDeleteIcon = e.target === this.deleteRef.current;
    if (isDeleteIcon && isShowConfirm) {
      return;
    }
    if (this.divRef.current && !this.divRef.current.contains(e.target)) {
      this.setState({
        isShowConfirm: false,
      });
      window.removeEventListener('mousedown', this.onMouseDown);
    }
  };

  showConfirm = (bool = true) => {
    this.setState({
      isShowConfirm: bool,
    });
  };

  onClickOk = () => {
    const { handleDelete } = this.props;
    handleDelete();
    this.setState({
      isShowConfirm: false,
    });
  };

  renderConfirm = () => {
    const { top, left } = this.deleteRef.current.getBoundingClientRect();

    const style = {
      top: top + 18,
      left: left - 10,
    };

    return (
      <div style={style} ref={this.divRef} className="popover-confirm">
        <div className="title">{I18n.t('alertPersonal.deleteAlert')}</div>
        <div className="button d-flex justify-content-around">
          <div onClick={this.onClickOk} className="ok">
            {I18n.t('alertPersonal.delete')}
          </div>

          <div onClick={() => this.showConfirm(false)} className="cancel">
            {I18n.t('alertPersonal.cancel')}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isShowConfirm } = this.state;
    return (
      <div className="confirm-delete">
        <i
          ref={this.deleteRef}
          onClick={() => this.showConfirm()}
          className="icon-bin-delete"
        />
        {isShowConfirm && ReactDOM.createPortal(this.renderConfirm(), this.div)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

ConfirmDelete.defaultProps = {
  handleDelete: () => {},
};

export default connect(mapStateToProps)(ConfirmDelete);
